/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from "react";
import { AccountInformationFormData } from './AccountInformation.Data'
import FormCreator from "../../../../../components/Forms/FormCreator";

const AccountInformation = forwardRef((props, ref) => {
    const accountInformationFormRef = useRef();
    const [accountInformationForm, SetAccountInformationForm] = useState(
        AccountInformationFormData
    );

    useImperativeHandle(ref, () => ({
        getFormData: () => {
            if (ref?.current) {
                const AccountInformationFormData =
                    accountInformationFormRef.current.getFormData();
                return AccountInformationFormData;
            }
            return null;
        },
    }));

    return (
        <div className="row">
            <FormCreator
                ref={accountInformationFormRef}
                {...accountInformationForm}
            />
        </div>
    );
});

export default AccountInformation;
